<template>
  <div class="dy-main-container app-container app-container-full">
    <template v-if="!hideLeftAside">
      <div class="dy-main-container-left" :style="{width: dividerOption.leftAsideWidth}">
        <slot name="left" />
      </div>
      <DyDragDivider
        v-bind="$props.dividerOption"
        :left-aside-width="dividerOption.leftAsideWidth"
        @change="leftAsideWidthChange"
      />
    </template>
    <div class="dy-main-container-right">
      <template v-if="!hideTopMenu">
        <div class="top-menu">
          <slot name="topMenu" />
        </div>
      </template>
      <div class="right-container">
        <div class="right-content">
          <slot name="right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DyDragDivider from './DYDragDivider'

export default {
  name: 'DyMainContainer',
  components: { DyDragDivider },
  props: {
    hideLeftAside: {
      type: Boolean,
      default: false
    },
    hideTopMenu: {
      type: Boolean,
      default: false
    },
    dividerOption: {
      type: Object,
      default: () => ({
        leftAsideWidth: 300
      })
    }
  },
  methods: {
    leftAsideWidthChange(value) {
      this.dividerOption.leftAsideWidth = value
    }
  }
}
</script>

<style lang="scss" scoped>
.dy-main-container {
  display: flex;

  .dy-main-container-left {
    height: 100%;
  }

  .dy-main-container-right {
    flex: 1;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 0 0 2px;

    .top-menu {
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      border-bottom: 1px solid #e4e7ed;
      padding: 0 5px;

      .el-button {
        font-size: 16px;
      }
    }

    .right-container {
      flex: 1;
      overflow: auto;
      position: relative;

      .right-content {
        height: 100%;
        padding: 10px 0 0 0;
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-sizing: border-box;
      }
    }
  }
}

::v-deep {
  .avue-crud--card {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .avue-crud__search {
      padding-right: 11px;
    }

    .avue-crud__body {
      flex: 1;

      .el-card__body {
        height: 100%;

        .el-form {
          height: 100%;

          .el-table {
            //.el-table__body-wrapper {
            //  background: rgb(243, 243, 243);
            //}
          }
        }
      }
    }
  }
  .avue-crud__pagination {
    padding: 2px;
  }
}

</style>
